import React, { useRef } from 'react';
import { Col, Label } from 'reactstrap';

import useAutosizeTextArea from '../hooks/useAutosizeTextArea';

interface IProps {
  value: string;
  handleChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  error?: string;
}
export const TextAreaMessage = ({ value, handleChange, error }: IProps) => {
  const getMessageLength = () => {
    return value?.length || 0;
  };

  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  useAutosizeTextArea(textAreaRef.current, value);

  return (
    <Col className={`mt-2`}>
      <Label htmlFor="course">Mensagem</Label>

      <div
        className={`form-control p-0 ${(getMessageLength() > 120 || error) && 'border-danger'}`}
      >
        <textarea
          name="message"
          ref={textAreaRef}
          rows={1}
          style={{
            resize: 'none',
            overflow: 'hidden',
          }}
          maxLength={240}
          value={value}
          onChange={handleChange}
          className={`form-control border-0`}
        />
        {getMessageLength() > 120 && (
          <div className="d-flex justify-content-end">
            <div
              style={{
                width: 'fit-content !important',
              }}
              className="alert-fade-right p-3"
            >
              <div
                className="alert text-danger bg-danger-subtle alert-dismissible alert-additional fade show mb-0"
                role="alert"
              >
                {/* <div className="alert-body">
                <div className="d-flex">
                  <div className="flex-shrink-0 me-3">
                    <i className="ri-alert-line fs-16 align-middle"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h5 className="alert-heading">Atenção</h5>
                  </div>
                </div>
              </div> */}
                <div className="alert-content d-flex">
                  <i className="me-2 ri-alert-line fs-16 align-middle"></i>
                  <span className="p-0 m-0">
                    A mensagem excede o limite recomendado de caracteres para
                    uma visualização ideal. Algumas partes podem não ser
                    exibidas corretamente na notificação.
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <span
        className={` d-flex justify-content-between mt-1 ${getMessageLength() > 120 && 'text-danger'}`}
      >
        {error && <div className="invalid-feedback d-block w-25">{error}</div>}
        {getMessageLength()} / 120
      </span>
    </Col>
  );
};
